﻿import { useAuthStore } from '@/modules/app/auth/authstore';

export const InRole = (el, binding, vnode) => {
    const auth = useAuthStore();
    let hasRole = auth.hasRole(binding.arg || binding.value);
    return vnode.el.hidden = !hasRole;
}